module.exports = __webpack_public_path__ + "static/img/first.bee66ff5.png";